var _path, _circle, _path2, _rect, _path3, _path4, _path5, _path6, _rect2, _path7, _path8, _path9, _path10, _path11, _path12, _rect3, _rect4, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 96,
    viewBox: "0 0 242 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.882 94.8476L27.3877 94.8477",
    stroke: "#8984FF",
    strokeWidth: 1.79946,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170.167,
    cy: 58.488,
    r: 6.73211,
    fill: "#FFDF70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.521 29.9391C152.521 20.1956 160.419 12.2969 170.163 12.2969C179.906 12.2969 187.805 20.1956 187.805 29.9391L187.805 46.4579L152.521 46.4579L152.521 29.9391Z",
    fill: "#85EEB2",
    stroke: "#8984FF",
    strokeWidth: 1.86745,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 148.263,
    y: 46.459,
    width: 43.7979,
    height: 10.3403,
    rx: 5.17013,
    fill: "#85EEB2",
    stroke: "#8984FF",
    strokeWidth: 1.86745,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.435 25.7676L199.894 26.1399L194.844 26.3027",
    stroke: "#8984FF",
    strokeWidth: 1.48514,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195.067 6.14258L192.093 11.701L190.792 14.1329",
    stroke: "#8984FF",
    strokeWidth: 1.48514,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.927 35.2442C119.927 29.5962 124.505 25.0176 130.153 25.0176H157.756C163.404 25.0176 167.982 29.5962 167.982 35.2442V84.3981C167.982 90.0462 163.404 94.6248 157.756 94.6248H130.153C124.505 94.6248 119.927 90.0462 119.927 84.3981V35.2442Z",
    fill: "white",
    stroke: "#8984FF",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.019 46.2129C126.019 44.556 127.362 43.2129 129.019 43.2129H158.626C160.283 43.2129 161.626 44.556 161.626 46.2129V56.5344C161.626 58.1913 160.283 59.5344 158.626 59.5344H129.019C127.362 59.5344 126.019 58.1913 126.019 56.5344V46.2129Z",
    fill: "url(#paint0_linear_2674_28393)",
    stroke: "#8984FF",
    strokeWidth: 1.61893
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 124.375,
    y: 31.5488,
    width: 38.6586,
    height: 5.56173,
    rx: 2.78086,
    fill: "#BCB9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.263 67.25L124.459 67.2515",
    stroke: "#8984FF",
    strokeWidth: 1.60381,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.106 75.1836L124.455 75.1834",
    stroke: "#8984FF",
    strokeWidth: 1.60381,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.864 19.6405C109.864 17.3465 108.005 15.4868 105.711 15.4868L75.2463 15.4868C72.9523 15.4868 71.0926 17.3465 71.0926 19.6405L71.0926 33.6851C71.0926 35.037 70.6474 36.3512 69.8259 37.4248L66.0849 42.3135C65.9373 42.5063 66.0748 42.7847 66.3176 42.7847L86.103 42.7847L105.711 42.7847C108.005 42.7847 109.864 40.925 109.864 38.6309L109.864 19.6405Z",
    fill: "white",
    stroke: "#8984FF",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.427 24.0161L78.6232 24.0176",
    stroke: "#8984FF",
    strokeWidth: 1.60381,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2705 31.9497L78.619 31.9495",
    stroke: "#8984FF",
    strokeWidth: 1.60381,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5449 61.1484C52.5449 55.6256 57.0221 51.1484 62.5449 51.1484H100.255C105.778 51.1484 110.255 55.6256 110.255 61.1484V84.6381C110.255 90.1609 105.778 94.6381 100.255 94.6381H62.5449C57.0221 94.6381 52.5449 90.1609 52.5449 84.6381V61.1484Z",
    fill: "white",
    stroke: "#8984FF",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0957,
    y: 57.6152,
    width: 41.1758,
    height: 5.56173,
    rx: 2.78086,
    fill: "#BCB9FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3984,
    y: 69.4004,
    width: 17.9941,
    height: 20.1574,
    rx: 4,
    transform: "rotate(90 81.3984 69.4004)",
    fill: "url(#paint1_linear_2674_28393)",
    stroke: "#8984FF",
    strokeWidth: 1.79946
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0986 72.2988H98.2471",
    stroke: "#8984FF",
    strokeWidth: 1.60381,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0986 79.6621H94.2627",
    stroke: "#8984FF",
    strokeWidth: 1.60381,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2674_28393",
    x1: 173.491,
    y1: 43.2129,
    x2: 170.16,
    y2: 68.4586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.410576,
    stopColor: "#FDCFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754862,
    stopColor: "#FFDF70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2674_28393",
    x1: 105.388,
    y1: 69.4004,
    x2: 96.1232,
    y2: 98.1344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.410576,
    stopColor: "#FDCFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754862,
    stopColor: "#FFDF70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses3);
export default __webpack_public_path__ + "static/media/courses-3.5cb18e64383e8f24583ca4a1aa91d49c.svg";
export { ForwardRef as ReactComponent };